export const GET_QUESTIONS_ERROR = "Une erreur est survenue lors du chargement des questions.";
export const UPDATE_QUESTION_ERROR = "Une erreur est survenue lors de la mise à jour de la question.";
export const ADD_QUESTION_ERROR = "Une erreur est survenue lors de l'ajout de la question.";
export const DELETE_QUESTION_ERROR = "Une erreur est survenue lors de la suppression de la question.";

export const GET_QUESTION_TYPES_ERROR = "Une erreur est survenue lors du chargement des types de question.";

export const GET_SURVEYS_ERROR = "Une erreur est survenue lors du chargement des questionnaires.";

export const GET_FEEDBACKS_ERROR = "Une erreur est survenue lors du chargement des avis clients.";

export const GET_FEEDBACKS_STATS_ERROR = "Une erreur est survenue lors du chargement des statistiques avis clients.";

export const UPDATE_FEEDBACKS_ERROR = "Une erreur est survenue lors de la mise à jour des avis.";

export const GET_NEW_FEEDBACKS_ERROR = "Une erreur est survenue lors du chargement du nombre de nouveaux avis.";


// WEBPACK FOOTER //
// ./src/errors/feedbacks.js